import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const SetEmailVerified = async () => {
  /**
   * input: uid: users id
   * output: user role
   * description: fetches user role
   */

  try {
    const codeDoc = await doc(db, "users", getAuth().currentUser.uid);

    await updateDoc(codeDoc, { verified_email: true });
    return;
  } catch (error) {
    console.log(error);
  }
};

export default SetEmailVerified;
